import { Pipe, PipeTransform } from '@angular/core';
import { VendorStatusEnum } from '../../enums/vendor-status';

@Pipe({
  name: 'vendorStatus',
  standalone: true,
})
export class VendorStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case VendorStatusEnum.QUALIFIED:
        return 'bg-success-500';

      case VendorStatusEnum.PENDING_QUALIFICATION:
        return 'bg-warning-700';

      case VendorStatusEnum.UNDER_MODIFICATION:
        return 'bg-warning-500';

      case VendorStatusEnum.REJECTED:
        return 'bg-destructive-500';

      case VendorStatusEnum.REVIEW:
        return 'bg-neutral-500';

      case VendorStatusEnum.NEW:
        return 'bg-primary-500';
    }
    return '';
  }
}
